"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDrawerOpen = exports.setTabs = exports.setSelectedTab = exports.receiveToken = void 0;

var ACTION_TYPE = _interopRequireWildcard(require("../actionTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var receiveToken = function receiveToken(token) {
  return {
    type: 'RECEIVE_TOKEN',
    token: token
  };
}; //tabs


exports.receiveToken = receiveToken;

var setSelectedTab = function setSelectedTab(value) {
  return {
    type: ACTION_TYPE.SET_SELECTED_TAB,
    value: value
  };
};

exports.setSelectedTab = setSelectedTab;

var setTabs = function setTabs(tabs) {
  return {
    type: ACTION_TYPE.SET_TABS,
    tabs: tabs
  };
};

exports.setTabs = setTabs;

var setDrawerOpen = function setDrawerOpen(drawerOpen) {
  return {
    type: ACTION_TYPE.SET_DRAWER_OPEN,
    drawerOpen: drawerOpen
  };
};

exports.setDrawerOpen = setDrawerOpen;